<template>
  <div class="task-exel">
    <div class="statis-box level-map">
      <div class="statis-box-title">任务执行情况</div>
      <ToolFliter class="toolFliter" @selectTime="selectTime" />
      <BarMap :rangeTime="rangeTime" :projectId="projectId" />
    </div>
    <div class="table-task">
      <el-table :data="tableData" v-loading="loading" row-key="id" height="500" border :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="title" label="成员" min-width="60" class="table-children" fixed>
        </el-table-column>
        <el-table-column prop="total_number_of_tasks" label="任务总数" min-width="60">
        </el-table-column>
        <el-table-column prop="completed_number_of_tasks" label="已完成" min-width="60">
        </el-table-column>
        <el-table-column prop="undone_number_of_tasks" label="未完成" min-width="60">
        </el-table-column>
        <el-table-column prop="overdue_number_of_tasks" label="逾期" min-width="60">
        </el-table-column>
        <el-table-column prop="archived_number_of_tasks" label="已归档" min-width="60">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import BarMap from './barMap'
import ToolFliter from './toolFliter'
import dayjs from "dayjs"
import api from '@/services/api/statistics/statistics'
import { list } from '@/const/taskExel'
export default {
  components: {
    BarMap,
    ToolFliter
  },
  data() {
    return {
      rangeTime: [],
      projectId: '',
      loading: false,
      taskExel: list,
      tableData: []
    }
  },
  created() {
    this.projectId = this.$route.query.projectId
  },
  mounted() {
  },
  methods: {
    selectTime(date) {
      this.rangeTime = [dayjs(new Date(date[0]).getTime()).format("YYYY-MM-DD"), dayjs(new Date(date[1]).getTime()).format("YYYY-MM-DD")]
      this.getTableData()
    },
    getTableData() {
      this.loading = true
      let params = {
        project_id: this.projectId,
        start_time: this.rangeTime[0],
        end_time: this.rangeTime[1],
      }
      api.userTaskCompletedOverview(params).then(res => {
        let arr = []
        res.forEach((item, index) => {
          for (let key in item) {
            let children = item[key].map((res, idx) => {
              return {
                id: index + '8888' + idx,
                title: res.realname,
                total_number_of_tasks: res.total_number_of_tasks,
                completed_number_of_tasks: res.completed_number_of_tasks,
                undone_number_of_tasks: res.undone_number_of_tasks,
                overdue_number_of_tasks: res.overdue_number_of_tasks,
                archived_number_of_tasks: res.archived_number_of_tasks,
              }
            })
            arr.push({
              id: index + 1,
              title: key,
              total_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.total_number_of_tasks, 0) || 0,
              completed_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.completed_number_of_tasks, 0) || 0,
              undone_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.undone_number_of_tasks, 0) || 0,
              overdue_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.overdue_number_of_tasks, 0) || 0,
              archived_number_of_tasks: item[key].reduce((totle, temp) => totle + temp.archived_number_of_tasks, 0) || 0,
              children
            })
          }
        })
        this.tableData = arr
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss">
.task-exel {
  .el-table__expanded-cell[class*="cell"] {
    padding: 0;
  }
  .table-children {
    tr {
      background-color: #f8f9fb;
    }
    td {
      border: 0 none;
    }
    &::before {
      display: none;
    }
    .el-table__expand-column {
      // visibility: hidden;
      i {
        visibility: hidden;
      }
    }
  }
  .toolFliter {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 99;
  }
  .el-table {
    border: 0 none;
    th,
    td {
      border-right: 0 none !important;
    }
    th {
      padding: 4px 0;
      font-size: 12px;
    }
  }
  .table-task .el-table {
    background-color: #fff;
    .el-table__header th {
      background-color: #fff !important;
    }
    td {
      background-color: #fff !important;
    }
  }
  .statis-box,
  .table-task {
    background-color: #fff;
    border-radius: 4px;
    position: relative;
    box-sizing: border-box;
  }
  .statis-box {
    border-bottom: 1px solid #e7e8ed;
  }
  .search-box {
    border: 0 none;
  }
  .level-map {
    height: 287px;
    position: relative;
    padding: 8px;
  }
  .statis-box-title {
    font-size: 14px;
    position: absolute;
    font-weight: bold;
    top: 16px;
    left: 16px;
    z-index: 999;
    &:hover {
      cursor: pointer;
    }
  }
  .el-table__fixed {
    box-shadow: 8px 0px 12px 0px rgba(0, 0, 0, 0.1) !important;
  }
}
</style>
